import { isValid, parseISO } from 'date-fns';
import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import BodyBaseBoldText from 'shared/components/vxl/typography/primary/body/BodyBaseBoldText';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import SuccessScreen from 'shared/patterns/vxl/SuccessScreen/SuccessScreen';
import theme from 'shared/styles/theme';
import { formatDate } from 'shared/utils/string/date';

const EXPIRY_DATE_FORMAT = 'MMMM d';
const EXPIRY_TIME_FORMAT = 'h:mm a';

const SetUpSuccess = () => {
  const { t: translatedText } = useTranslation('payLater', {
    keyPrefix: 'setUpSuccess',
  });
  const dismissToTab = useDismissToRootTab();
  const { expiresAt } = useLocalSearchParams<{ expiresAt?: string }>();
  const parsedExpiry = expiresAt ? parseISO(expiresAt) : null;
  const expiryDate =
    parsedExpiry && isValid(parsedExpiry) ? parsedExpiry : null;

  const goHome = () => {
    dismissToTab(Tabs.HOME);
  };

  useBackHandler(goHome);

  return (
    <View style={styles.screen}>
      <Stack.Screen
        options={{
          headerShown: true,
          gestureEnabled: false,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar {...props} empty primaryIcon={null} />
          ),
        }}
      />
      <SuccessScreen
        visual="DEBIT_CARD_A_STATIC_SQUARE"
        eyebrowText={translatedText('eyebrow')}
        titleText={translatedText('title')}
        primaryButton={{
          label: translatedText('done'),
          onPress: goHome,
        }}
        content={
          <View style={styles.content}>
            <BodyBaseText numberOfLines={0} style={styles.centeredText}>
              {translatedText('checkoutInstructionStart')}{' '}
              <BodyBaseBoldText>
                {translatedText('checkoutInstructionCredit')}
              </BodyBaseBoldText>
              {translatedText('checkoutInstructionEnd')}
            </BodyBaseText>
            {expiryDate ? (
              <BodyBaseText numberOfLines={0} style={styles.centeredText}>
                {translatedText('useBy', {
                  date: formatDate(expiryDate, EXPIRY_DATE_FORMAT),
                  time: formatDate(expiryDate, EXPIRY_TIME_FORMAT),
                })}
              </BodyBaseText>
            ) : null}
          </View>
        }
      />
    </View>
  );
};

const styles = StyleSheet.create({
  centeredText: { textAlign: 'center' },
  content: { gap: theme.spacing.l },
  screen: { backgroundColor: theme.color.background.primary, flex: 1 },
});

export default SetUpSuccess;
